import styled from 'styled-components';

import { screenLargerThan } from 'utils/style/responsive';

import HoverIcon from 'components/HoverIcon';

export const TemplateFieldRow = styled('div')`
  align-items: center;
  border-radius: 10px;
  border: 1px dashed #ddd;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 1rem;
  position: relative;
  & > div {
    width: 100%;
    margin-top: 0.5rem;
  }
  ${screenLargerThan.tablet`
    flex-direction: row;
    & > div {
      flex: 1;
      margin-left: 1rem;
    }
  `}
`;

export const InputRowContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;

export const RemoveIcon = styled(HoverIcon)`
  position: absolute;
  top: 0.5rem;
  ${(props) =>
    props.theme.direction === 'rtl' ? 'left: 0.5rem;' : 'right: 0.5rem;'}
`;
